const handleStart = (state, action) => {
  const { originalMessage, isOpen } = action
  return {
    ...state,
    originalMessage,
    editing: true,
    newMessage: originalMessage.content ?? '',
    isOpen: isOpen
  }
}

const handleEdit = (state, action) => {
  const { message } = action
  return { ...state, newMessage: message }
}

const handleReset = (state, action) => {
  return initialState
}

const handleQoute = (state, action) => {
  const { message } = action
  return { ...state, editing: false, quoting: true, newMessage: message }
}

export const initialState = {
  editing: false,
  originalMessage: null,
  newMessage: '',
  isOpen: false,
  quoting: false
}

export const Actions = {
  START: 'START',
  EDIT: 'EDIT',
  RESET: 'RESET',
  QUOTE: 'QUOTE'
}

const Handlers = {
  [Actions.START]: handleStart,
  [Actions.EDIT]: handleEdit,
  [Actions.RESET]: handleReset,
  [Actions.QUOTE]: handleQoute
}

export const ChatEditStateReducer = (state, action) => {
  const { type } = action

  if (type in Handlers) {
    return Handlers[type](state, action)
  }

  throw new Error(`Unknown ChatEditState reducer type: ${type}`)
}
